import {  PromiseObservable  } from './PromiseObservable';

export const fromPromise = PromiseObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/fromPromise.ts